import { useState } from 'react';

/**
 * Generates a fresh UUID-based idempotency key. Falls back to a
 * timestamp+random token when crypto.randomUUID is unavailable.
 */
export function generateIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  return `idemp-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

/**
 * Generates a stable UUID-based idempotency key on component mount.
 * The key is stable for the lifetime of the component and changes on remount.
 */
export function useIdempotencyKey(): string {
  const [key] = useState(generateIdempotencyKey);
  return key;
}
